import {
  CheckCodeLegacy,
  CheckCodeNew,
  CheckSkuFormLegacy,
  CheckSkuFormNew,
} from "./Module/Customer";
import { isNewApiEnabled } from "./customerProfileFetch";

function extractResponseData(res) {
  return res?.data ?? res?.response?.data;
}

export async function checkSkuFormWithFallback({ data }) {
  const _return = {
    status: false,
    result: null,
    source: "legacy",
  };

  if (isNewApiEnabled()) {
    try {
      const res = await CheckSkuFormNew({ data });
      const responseData = extractResponseData(res);

      if (responseData?.resultCode === "20000") {
        return {
          status: true,
          result: responseData.resultData,
          source: "new",
        };
      }

      console.log(
        "[checkSkuForm] new API non-success, fallback to legacy >>",
        responseData,
      );
    } catch (e) {
      console.log("[checkSkuForm] new API failed, fallback to legacy >>", e);
    }
  }

  try {
    const res = await CheckSkuFormLegacy({ data });
    const responseData = extractResponseData(res);

    if (responseData?.resultCode === "20000") {
      _return.status = true;
      _return.result = responseData.resultData;
      _return.source = "legacy";
    }
  } catch (e) {
    console.log("[checkSkuForm] legacy API failed >>", e);
  }

  return _return;
}

export async function checkCodeWithFallback({ params }) {
  const _return = {
    status: false,
    result: null,
    source: "legacy",
  };

  if (isNewApiEnabled()) {
    try {
      const res = await CheckCodeNew({ params });
      const responseData = extractResponseData(res);

      if (responseData?.resultCode === "20000") {
        return {
          status: true,
          result: responseData.resultData,
          source: "new",
        };
      }

      console.log(
        "[checkCode] new API non-success, fallback to legacy >>",
        responseData,
      );
    } catch (e) {
      console.log("[checkCode] new API failed, fallback to legacy >>", e);
    }
  }

  try {
    const res = await CheckCodeLegacy({ params });
    const responseData = extractResponseData(res);

    if (responseData?.resultCode === "20000") {
      _return.status = true;
      _return.result = responseData.resultData;
      _return.source = "legacy";
    }
  } catch (e) {
    console.log("[checkCode] legacy API failed >>", e);
  }

  return _return;
}
